const icon = require('vue-svgicon');
icon.register({
    'lens-feature-anti-blue': {
        width: 40,
        height: 40,
        viewBox: '0 0 40 40',
        data: `<path pid="0" d="M10 20h20.5M10 15l17-9M10 25l17 9" _stroke="#000"/>`,
    },
});
